// WMS Ekran Ayarları (Toplama / Paketleme / Mal Kabul / Stok Sayım) ortak sayfa rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.screenSetup';

export const wmsScreenSetupGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'WMS ekranları nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Toplama, Paketleme, Mal Kabul ve Stok Sayım ayarları sayfaları aynı şekilde çalışır: depoya bir el terminali ekranı eklersiniz ve o ekranı kullanacak personeli seçersiniz. Personel yalnız yetkili olduğu ekrana girebilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ekran ayarları başlığı'),
    filters: t(`${G}.regions.filters`, 'Depo'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni … Ekranı'),
    table: t(`${G}.regions.table`, 'Ekran listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Depoyu seçin'),
      text: t(`${G}.s1.text`, '"Depo" listesinden akıllı depoyu seçin; liste o depodaki bu türden ekranları gösterir. Bir depoda birden fazla ekran olabilir (ör. her terminal ya da vardiya için ayrı).'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Ekran oluşturun'),
      text: t(`${G}.s2.text`, '"Yeni … Ekranı" (ör. "Yeni Toplama Ekranı") düğmesiyle Ekran Adı (zorunlu) girin, "Aktif" kutusunu işaretli bırakıp kaydedin. Satırdaki ⋮ menüsünden "Düzenle" ile adı ve aktiflik durumunu değiştirebilirsiniz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Personel yetkisi verin'),
      text: t(`${G}.s3.text`, '⋮ menüsündeki "Personel Yönetimi" penceresinde "Personel Ara/Seç" ile bu ekranı kullanacak personeli ekleyin, çöp kutusuyla çıkarın ve kaydedin. Listedeki bir personele tıklayınca sağdaki "Yetki Ayarları"nda eylem izinlerini (Eksik Bildir, İş Emri İptal, İş Emri Yeniden Atama, Siparişi Kendine Atayabilsin, İş Emrini Tamamla, Sortlama) açıp kapatırsınız.'),
      tips: [
        t(`${G}.s3.tip1`, '"Personel" sütunu bu ekrana yetkili kişi sayısını gösterir.'),
        t(`${G}.s3.tip2`, 'Personel ekrana kendi kullanıcı e-postasıyla girer; personel kaydı yoksa ya da bu ekrana yetkisi yoksa "Bu ekrana erişim yetkiniz yok" uyarısı alır. Yönetici ekranı önizleme olarak açabilir.'),
        t(`${G}.s3.tip3`, 'İş emri ve mal kabul / sayım görevi atarken listede yalnız ilgili ekrana yetkili personel çıkar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Ekranı açın'),
      text: t(`${G}.s4.text`, '"Ekrana Git" ekranı açar. Bu adresi el terminalinin tarayıcısında açıp yer imi olarak kaydedin; personel her vardiyada aynı adresten girer.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Ekranı silin'),
      text: t(`${G}.s5.text`, '⋮ menüsündeki "Sil", altta kırmızı bir onay şeridi açar; "Sil"e basınca ekran listeden kaldırılır.'),
    },
  ],
});
